import React, { Component } from 'react';
import { Redirect, withRouter, Link } from 'react-router-dom';
import pkceChallenge from 'pkce-challenge';
import axios from "axios";

import TopBar from './../../TopBar';
import Footer from './../../Footer';
import { Row, Col } from 'reactstrap';

import {
  _setSSOToken,
  logToLocalStorage,
  decodeIdToken
} from './ssoutils';
import { Publisher } from "./../../../pubsub/publisher.js";


function downloadSSOLogs() {
  const logs = localStorage.getItem("sso_logs");
  if (!logs) return;

  const blob = new Blob([logs], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "sso-debug.json";
  link.click();
}

function clearSSOLogs() {
  localStorage.removeItem("sso_logs");
  window.location.reload();
}
export default withRouter(class Login extends Component {
  constructor(props) {
	super(props);
	this.state = {
	  authenticated: null,
	  fetchInProgress: false,
	  authToken: false,
	  error: false,
	  errorMessage: false
	};
  }

  componentDidMount() {
	const url = window.location.href;

	if (url.includes('dashboard')) {
	  const codes = pkceChallenge();
	  sessionStorage.setItem('code_challenge', codes.code_challenge);
	  sessionStorage.setItem('code_verifier', codes.code_verifier);

	  const ELLIMAN_AUTH_URL = `${process.env.ELLIMAN_BASE_URL}oauth2/v2.0/authorize?` +
		`client_id=${process.env.ELLIMAN_CLIENT_ID}` +
		`&redirect_uri=${encodeURIComponent(process.env.ELLIMAN_REDIRECT_URI)}` +
		`&response_type=code` +
		`&scope=openid%20profile%20email%20offline_access` +
		`&state=58df5ac782ff4b509e9d670e037a887a` +
		`&code_challenge=${codes.code_challenge}` +
		`&code_challenge_method=S256` +
		`&response_mode=query`;

	  logToLocalStorage("sso_authorize_redirect_started", { redirectUrl: ELLIMAN_AUTH_URL });

	  window.location.href = ELLIMAN_AUTH_URL;

	} else if (url.includes('sso')) {
	  const params = new URLSearchParams(window.location.search);
	  const code = params.get('code');
	  const error = params.get('error');
	  const error_description = params.get('error_description');

	  if (error) {
		const message = error_description
		  ? decodeURIComponent(error_description.replace(/\+/g, " "))
		  : "Authorization failed, please contact your support team.";

		logToLocalStorage("sso_auth_error", { error, message });

		this.setState({
		  error,
		  errorMessage: message
		});
	  } else {
		logToLocalStorage("sso_token_request", { code });
		this._getAuthToken({ code });
	  }

	} else {
	  const query = window.location.search.replace("?", "");
	  const hashObject = query.split('&').reduce((res, item) => {
		const parts = item.split('=');
		res[parts[0]] = parts[1];
		return res;
	  }, {});

	  if (hashObject['error']) {
		const message = hashObject['error_description']
		  ? decodeURIComponent(hashObject['error_description'].replace(/\+/g, " "))
		  : "Authorization failed, please contact your support team.";

		logToLocalStorage("sso_url_error", {
		  error: hashObject['error'],
		  message
		});

		this.setState({
		  error: hashObject['error'],
		  errorMessage: message
		});
	  }
	}
  }

  _getAuthToken = ({ code }) => {
	if (!this.state.fetchInProgress) {
	  this.setState({ fetchInProgress: true });
	}

	const params = new URLSearchParams();
	params.append('client_id', process.env.ELLIMAN_CLIENT_ID);
	params.append('redirect_uri', process.env.ELLIMAN_REDIRECT_URI);
	params.append('grant_type', "authorization_code");
	params.append('code', code);
	params.append('code_verifier', sessionStorage.getItem('code_verifier'));

	axios.post(`${process.env.ELLIMAN_BASE_URL}oauth2/v2.0/token`, params)
	  .then((res) => {
		if (res.data && res.data.id_token) {
		   const decodedClaims = decodeIdToken(res.data.id_token);
		  logToLocalStorage("sso_token_success", {
			id_token_prefix: res.data.id_token.substring(0, 12) + "...",
			access_token_present: !!res.data.access_token,
			claims: decodedClaims
		  });

		  _setSSOToken(res.data, "ELLIMAN");
		  this.setState({ authToken: res.data });
		} else {
		  logToLocalStorage("sso_token_empty_response", { res: res.data });
		}
	  })
	  .catch((error) => {
		logToLocalStorage("sso_token_error", {
		  params: params,
		  message: error.toString(),
		  response: error.response && error.response.data ? error.response.data : null
		});
	  });
  }

  render() {
	const { authToken, error, errorMessage } = this.state;
	const { match } = this.props;

	if (authToken) {
	  return <Redirect to={{ pathname: `/dashboard` }} />;
	}

	if (window.location.href.includes('sso') && !error) return null;

	return (
	  <div className="plan__wrapper share__wrapper">
		<TopBar goTo={'plans'} />
		<Row className="login-container login">
		  <Col lg={12} className="pt-0 signin">
			<div className={`widget-container login elliman`}>
			  <div className="sso-logo-container">
				<div className="sso-logo" />
			  </div>
			  <h4 className="text-center mt-5 mb-2">Douglas Elliman Agent Login</h4>
			  <div className="sub-text">Douglas Elliman NYC agents only. <br/> You will be redirected to sign in.</div>
			  <Link className="mt-5 button" to={`/dashboard/elliman`}>
				Sign In
			  </Link>
			  {error && (
				<div className="sub-text mt-3" style={{ color: "#F53246" }}>
				  {errorMessage}
				</div>
			  )}
			  <div className="signin-toggle mt-5">
				Not a Douglas Elliman agent? <Link to={`/pricing`}>Sign Up</Link> or <Link to={`/login`}>Sign In</Link>
			  </div>
			  <p className="disclaimer">
				By signing in, you agree to our <a href="https://marketproof.com/terms-of-use" target="_blank">Terms of Service</a> and
				<a href="https://marketproof.com/privacy-policy" target="_blank"> Privacy Policy</a>.
			  </p>
			  {localStorage.getItem("sso_logs") && (
				<div style={{ textAlign: "center", marginTop: "2rem" }}>
				  <a
					href="#"
					onClick={(e) => {
					  e.preventDefault();
					  downloadSSOLogs();
					}}
					style={{ fontSize: "12px", color: "#888", textDecoration: "underline", marginRight: "1rem" }}
				  >
					Download Debug Logs
				  </a>
				  <a
					href="#"
					onClick={(e) => {
					  e.preventDefault();
					  clearSSOLogs();
					}}
					style={{ fontSize: "12px", color: "#888", textDecoration: "underline" }}
				  >
					Clear Logs
				  </a>
				</div>
			  )}
			</div>
		  </Col>
		</Row>
		
		<Footer />
	  </div>
	);
  }
});
